import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/CatalogSearch.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/catalogSearch`;
	}
	query(e) {
		return this.api.post(this.buildPath(n.baseUrl), e);
	}
};
//#endregion
export { n as CatalogSearch };

//# sourceMappingURL=CatalogSearch.js.map